import { render, staticRenderFns } from "./FilterFoot.vue?vue&type=template&id=6d2f84bd&"
import script from "./FilterFoot.vue?vue&type=script&lang=js&"
export * from "./FilterFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports